const ScrollToDataroom = {
  init: () => {
    const url = new URL(window.location.href);
    const urlSearchParams = new URLSearchParams(url.search);
    if (Array.from(urlSearchParams.values()).includes('dataroom')) {
      if (urlSearchParams.has('eqt_society')) {
        const accordionSection = document.getElementById('edit-group-additional-information');
        if (accordionSection) {
          accordionSection.setAttribute('open', 'true');
        }
      }
      if (urlSearchParams.has('eqt_investor')) {
        const accordionSection = document.getElementById('edit-group-key-informations');
        if (accordionSection) {
          accordionSection.setAttribute('open', 'true');
        }
      }
      if (urlSearchParams.has('eqt_support_structure')) {
        const accordionSection = document.getElementById('edit-group-futher-information');
        if (accordionSection) {
          accordionSection.setAttribute('open', 'true');
        }
      }
      const dataroomField = document.getElementById('edit-field-dataroom-other');
      if (dataroomField) {
        setTimeout(function scroll() {
          dataroomField.scrollIntoView({ behavior: 'smooth' });
        }, 250);
      }
    }
  },
};
export default ScrollToDataroom;
